// extracted by mini-css-extract-plugin
module.exports = {"span":"index_span__3qASm","primary":"index_primary__3goA9"};